export default __webpack_public_path__ + "static/media/OneMoreCoffee.967c9408.png";